import { useEffect } from "react";
import { reaction } from "mobx";
import { Modal } from "components/UI";
import translationStore from "stores/translation-store";
import UserStore from "utils/user/store";
import { useUser } from "utils/user/lib";

let authPopup = null;
let authEventsInited = false;

/**
 * @param {import('utils/user/store').default} user
 */
const showAuthentication = (user) =>
{
  if(authPopup && authPopup.closed === false) {
    authPopup.focus();
  } else {
    authPopup = window.open(`${process.env.ACCOUNT_URL}/login?redirect_uri=${window.location.href}&locale=${translationStore.language}&response_mode=web_message`, "MyAlbumAuth", "width=550,height=700");

    // Popup werd geblokkeerd door de browser (bv. niet vanuit een user gesture aangeroepen)
    if(!authPopup)
      return null;

    authPopup.moveTo((window.innerWidth - 550) / 2 + window.screenX, (window.innerHeight - 700) / 2 + window.screenY);
    authPopup.resizeTo(550, 700);
    authPopup.focus();

    if(!authEventsInited) {
      window.addEventListener("message", (event) => {
        if(event.origin === process.env.ACCOUNT_URL) {
          if(event.data.status === "ok") {
            // Login in-sessie afronden (geen page reload) zodat openstaande
            // modals/flows behouden blijven. De reaction op user.isLoggedIn in
            // whenAuthenticated pikt dit vervolgens op.
            user.completeLogin().catch(() => {
              // Fallback: mocht in-sessie afronden mislukken, dan alsnog herladen
              // zodat de sessie in ieder geval opgepikt wordt.
              window.location.reload();
            });
          }
        }
      });
      authEventsInited = true;
    }

    authPopup.addEventListener("close", () => {
      authPopup = null
    });
  }

  return authPopup;
}

const hideAuthentication = () =>
{
  authPopup?.close();
}

/**
 * @param {import('utils/user/store').default} user
 */
const whenAuthenticated = (user) =>
{
  return new Promise((resolve, reject) =>
  {
    if(user.isLoggedIn)
      return resolve();

    const disposeReaction = reaction(
      () => user.isLoggedIn,
      (isLoggedIn, _, _reaction) => {
        hideAuthentication();

        if(isLoggedIn)
          resolve();
        else
          reject();

        _reaction.dispose();
      }
    );

    // Wanneer de browser het inlogvenster blokkeert krijgen we geen popup terug.
    // We stoppen dan de reaction en laten de aanroeper weten dat de popup geblokkeerd is.
    const popup = showAuthentication(user);
    if(!popup) {
      disposeReaction();
      reject({ error: "popup_blocked" });
    }
  });
}

function MyAuthenticationModal() {
  const user = useUser();
  
  useEffect(() => {
    showAuthentication(user);

    return () => {
      hideAuthentication();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export {
  MyAuthenticationModal,
  showAuthentication,
  hideAuthentication,
  whenAuthenticated
}